import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import DeviceCommentsPanel from './DeviceCommentsPanel';

/** Device comments outside the risk card so the card height stays fixed. */
export default function DeviceCommentsModal({ deviceId, serialNumber, onClose }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[70] flex items-start justify-center overflow-y-auto bg-slate-950/60 p-3 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Комментарии"
    >
      <button
        type="button"
        aria-label="Закрыть"
        className="fixed inset-0 cursor-default"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-4 shadow-lg dark:border-slate-800 dark:bg-slate-950">
        <DeviceCommentsPanel deviceId={deviceId} serialNumber={serialNumber} onClose={onClose} />
      </div>
    </div>,
    document.body,
  );
}
